/* ================================
   Firebase + Firestore (CDN)
   ================================ */
(function () {

  // 1️⃣ Load Firebase scripts dynamically (Shopify-safe)
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  Promise.all([
    loadScript("https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js"),
    loadScript("https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore-compat.js")
  ]).then(initFirestore);

  function initFirestore() {

    /* ================================
       2️⃣ Firebase config
       ================================ */
        const firebaseConfig = {
        apiKey: "AIzaSyANYozYWioBP5nQb6UzCR9Voq6TZF3tHpk",
        authDomain: "bv-uk-search-terms.firebaseapp.com",
        projectId: "bv-uk-search-terms",
        storageBucket: "bv-uk-search-terms.firebasestorage.app",
        messagingSenderId: "432015201717",
        appId: "1:432015201717:web:44593870cf7de9ef22f5fc",
        measurementId: "G-XX3K04TRMB"
        };

    firebase.initializeApp(firebaseConfig);
    var db = firebase.firestore();

    /* ================================
       3️⃣ Debounce helper
       ================================ */
    function debounce(fn, delay) {
      var timer;
      return function () {
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(null, args);
        }, delay || 600);
      };
    }

    /* ================================
       4️⃣ Session ID (optional but useful)
       ================================ */
    var sessionId = sessionStorage.getItem("search_session_id");
    if (!sessionId) {
      sessionId = Math.random().toString(36).slice(2);
      sessionStorage.setItem("search_session_id", sessionId);
    }

    var lastStoredTerm = "";

    /* ================================
       5️⃣ Firestore write
       ================================ */
    var storeSearchTerm = debounce(function (term) {
      var cleaned = term.trim().toLowerCase();

      if (cleaned.length < 4) return;
      if (cleaned === lastStoredTerm) return;

      lastStoredTerm = cleaned;

      db.collection("search_terms_bvus").add({
        term: cleaned,
        sessionId: sessionId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      }).catch(function (err) {
        console.warn("Search term not saved", err);
      });

    }, 700);

    /* ================================
       6️⃣ Hook into your live search
       ================================ */

      var elements = document.querySelectorAll(`div.product-card:not(${window.innerWidth >= 768 ? ".mobile-show" : ".mobile-hide"})`),
        noResults = document.querySelector(".no-items"),
        filters = document.querySelectorAll(".shop-list__filters input"),
        headings = document.querySelectorAll(".product-heading"),
        selectedCategory = "s";

    document.getElementById("searchShop").addEventListener("keyup", function () {
        elements.forEach((element) => {
            element.style.display = "none";
        });
        filters.forEach((filter) => {
            filter.classList.remove("active");
        });
        this.value.length > 0
            ? headings.forEach((heading) => {
                heading.style.display = "none";
            })
            : headings.forEach((heading) => {
                heading.style.display = "block";
            });

        var searchRelated = document.querySelectorAll(`div.product-card[data-search*='${this.value.toLowerCase()}']`);
        if (searchRelated.length > 0) {
            noResults.style.display = "none";
            searchRelated.forEach((element) => {
                element.style.display = "block";
            });
        } else {
            noResults.style.display = "block";
        }

        if (this.value.length == 0) {
            elements.forEach((element) => {
                element.style.display = "block";
                noResults.style.display = "none";
            });
            var prevSelected = document.querySelectorAll(`div.product-card[data-filter*='${selectedCategory}']`);
            prevSelected.forEach((element) => {
                element.style.display = "block";
            });
        }
          storeSearchTerm(this.value.toLowerCase());
    });

    window.addEventListener("keydown", function (e) {
        // check if ctrl (or cmd on osx) + shift + F is pressed
        if (e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70)) {
            e.preventDefault();
            // TODO: change the ID on your search box

            document.getElementById("searchShop").focus();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    });

    // Enhanced filter functionality for all filter types
    const productTypeCheckboxes = document.querySelectorAll('input[name="product-type"]');
    const benefitCheckboxes = document.querySelectorAll('input[name="benefit"]');
    const forEveryBodyCheckboxes = document.querySelectorAll('input[name="for-every-body"]');
    const allProductCards = document.querySelectorAll("div.product-card");

    function filterProducts() {
        // Get checked filters from all categories
        const checkedTypes = Array.from(productTypeCheckboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value.toLowerCase());

        const checkedBenefits = Array.from(benefitCheckboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value.toLowerCase());

        const checkedForEveryBody = Array.from(forEveryBodyCheckboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value.toLowerCase());

        // Check if "All Products" is selected
        const allProductsCheckbox = Array.from(productTypeCheckboxes).find((cb) => cb.value === "s");
        const showAllProducts = allProductsCheckbox && allProductsCheckbox.checked;

        // If "All Products" is checked and no other filters are active, show all products
        if (showAllProducts && checkedBenefits.length === 0 && checkedForEveryBody.length === 0) {
            allProductCards.forEach((card) => {
                card.style.display = "block";
            });
            document.querySelectorAll(".product-heading").forEach((heading) => {
                heading.style.display = "block";
            });
            noResults.style.display = "none";
            return;
        }

        // Hide all products first
        allProductCards.forEach((card) => {
            card.style.display = "none";
        });

        // Filter products based on all active filters
        let hasVisibleProducts = false;

        allProductCards.forEach((card) => {
            const cardFilters = card.getAttribute('data-filter').toLowerCase().split(' ');
            let shouldShow = true;

            // Check product type filters (if any are selected and not "All Products")
            if (checkedTypes.length > 0 && !showAllProducts) {
                const typeMatch = checkedTypes.some(type => cardFilters.includes(type));
                if (!typeMatch) shouldShow = false;
            }

            // Check benefit filters (if any are selected)
            if (checkedBenefits.length > 0 && shouldShow) {
                const benefitMatch = checkedBenefits.some(benefit => cardFilters.includes(benefit));
                if (!benefitMatch) shouldShow = false;
            }

            // Check "For Every Body" filters (if any are selected)
            if (checkedForEveryBody.length > 0 && shouldShow) {
                // This would require additional data attributes on products for dietary restrictions
                // For now, we'll skip this filter as it's not implemented in the product data
            }

            if (shouldShow) {
                card.style.display = "block";
                hasVisibleProducts = true;
            }
        });

        // Show/hide category headings based on visible products
        document.querySelectorAll(".product-heading").forEach((heading) => {
            const nextElements = [];
            let nextSibling = heading.nextElementSibling;

            // Collect all product cards until the next heading
            while (nextSibling && !nextSibling.classList.contains("product-heading")) {
                if (nextSibling.classList.contains("product-card")) {
                    nextElements.push(nextSibling);
                }
                nextSibling = nextSibling.nextElementSibling;
            }

            // Show heading only if at least one product in its section is visible
            const hasVisibleInSection = nextElements.some((el) => el.style.display !== "none");
            heading.style.display = hasVisibleInSection ? "block" : "none";
        });

        // Show/hide no results message
        noResults.style.display = hasVisibleProducts ? "none" : "block";
    }

    // Add event listeners to product-type checkboxes
    productTypeCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function (ev) {
            // If "All Products" is checked, uncheck all other product type filters
            if (this.value === "s" && this.checked) {
                productTypeCheckboxes.forEach((cb) => {
                    if (cb !== this && cb.value !== "best-sellers") cb.checked = false;
                });
            } else if (this.checked && this.value !== "s" && this.value !== "best-sellers") {
                // If any specific product type is checked, uncheck "All Products"
                const allCheckbox = Array.from(productTypeCheckboxes).find((cb) => cb.value === "s");
                if (allCheckbox) allCheckbox.checked = false;
            }

            filterProducts();
        });
    });

    // Add event listeners to benefit checkboxes
    benefitCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function (ev) {
            filterProducts();
        });
    });

    // Add event listeners to "For Every Body" checkboxes
    forEveryBodyCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", function (ev) {
            filterProducts();
        });
    });

    // Clear all filters function
    function clearAllFilters() {
        productTypeCheckboxes.forEach((cb) => {
            cb.checked = false;
        });
        benefitCheckboxes.forEach((cb) => {
            cb.checked = false;
        });
        forEveryBodyCheckboxes.forEach((cb) => {
            cb.checked = false;
        });

        // Check "All Products" by default
        const allProductsCheckbox = Array.from(productTypeCheckboxes).find((cb) => cb.value === "s");
        if (allProductsCheckbox) allProductsCheckbox.checked = true;

        filterProducts();
    }

    // Add clear filters functionality (you can call this function from a button if needed)
    window.clearAllFilters = clearAllFilters;

    // Sort functionality for #sortShop
    const sortSelect = document.querySelectorAll(".sortShop");
    const productContainer = document.querySelector(".shop-list__list");

    if (sortSelect && productContainer) {
        sortSelect.forEach((select) => {
            select.addEventListener("change", function () {
                const sortValue = this.value;
                const products = Array.from(productContainer.querySelectorAll("div.product-card"));
                const headings = Array.from(productContainer.querySelectorAll(".product-heading"));
                const noItems = productContainer.querySelector(".no-items");

                // Remove headings temporarily for sorting
                headings.forEach((heading) => heading.remove());

                // Sort products based on selected option
                products.sort((a, b) => {
                    switch (sortValue) {
                        case "alphabetical-asc":
                            const nameA = a.querySelector("h4 span")?.textContent.toLowerCase() || "";
                            const nameB = b.querySelector("h4 span")?.textContent.toLowerCase() || "";
                            return nameA.localeCompare(nameB);

                        case "alphabetical-desc":
                            const nameDescA = a.querySelector("h4 span")?.textContent.toLowerCase() || "";
                            const nameDescB = b.querySelector("h4 span")?.textContent.toLowerCase() || "";
                            return nameDescB.localeCompare(nameDescA);

                        case "price-asc":
                            const priceTextA = a.querySelector("span small")?.textContent || "0";
                            const priceTextB = b.querySelector("span small")?.textContent || "0";
                            const priceA = parseFloat(priceTextA.replace(/starts at $|\/box|,/g, "") || "0");
                            const priceB = parseFloat(priceTextB.replace(/starts at $|\/box|,/g, "") || "0");
                            return priceA - priceB;

                        case "price-desc":
                            const priceHighTextA = a.querySelector("span small")?.textContent || "0";
                            const priceHighTextB = b.querySelector("span small")?.textContent || "0";
                            const priceHighA = parseFloat(priceHighTextA.replace(/starts at $|\/box|,/g, "") || "0");
                            const priceHighB = parseFloat(priceHighTextB.replace(/starts at $|\/box|,/g, "") || "0");
                            return priceHighB - priceHighA;

                        case "featured":
                        default:
                            // Keep original order for featured/best selling
                            return 0;
                    }
                });

                // Clear container and re-append sorted products
                productContainer.innerHTML = "";

                // Always add the no-items element first
                if (noItems) {
                    productContainer.appendChild(noItems);
                }

            if (sortValue === "featured" || sortValue === "best-sellers") {
              // For featured/best-sellers, restore original order with headings
              // Restore original structure with headings
              const supplementsHeading = document.createElement("h3");
              supplementsHeading.className = "product-heading";
              supplementsHeading.textContent = "Supplements";
              productContainer.appendChild(supplementsHeading);

              products
                .filter((p) => p.dataset.filter && p.dataset.filter.includes("supplements"))
                .forEach((product) => {
                  productContainer.appendChild(product);
                });

              const gummiesHeading = document.createElement("h3");
              gummiesHeading.className = "product-heading";
              gummiesHeading.textContent = "Gummies";
              productContainer.appendChild(gummiesHeading);

              products
                .filter((p) => p.dataset.filter && p.dataset.filter.includes("gummies"))
                .forEach((product) => {
                  productContainer.appendChild(product);
                });

              const sportsHeading = document.createElement("h3");
              sportsHeading.className = "product-heading";
              sportsHeading.textContent = "Sports";
              productContainer.appendChild(sportsHeading);

              products
                .filter((p) => p.dataset.filter && (p.dataset.filter.includes("sports") || p.dataset.filter === "specialties mens womens sports"))
                .forEach((product) => {
                  productContainer.appendChild(product);
                });

              const kidsHeading = document.createElement("h3");
              kidsHeading.className = "product-heading";
              kidsHeading.textContent = "Kids";
              productContainer.appendChild(kidsHeading);

              products
                .filter((p) => p.dataset.filter && p.dataset.filter.includes("kids"))
                .forEach((product) => {
                  productContainer.appendChild(product);
                });

              const specialtiesHeading = document.createElement("h3");
              specialtiesHeading.className = "product-heading";
              specialtiesHeading.textContent = "Specialties";
              productContainer.appendChild(specialtiesHeading);

              products
                .filter((p) => p.dataset.filter && p.dataset.filter.includes("specialties") && !p.dataset.filter.includes("sports"))
                .forEach((product) => {
                  productContainer.appendChild(product);
                });
            } else {
                    // For other sorts, just append all products in sorted order
                    products.forEach((product) => {
                        productContainer.appendChild(product);
                    });
                }
            });
        });
    }
    if (!!window.location.hash) {
        document.querySelector(`.shop-list__filters input[value*='${window.location.hash.replace("#", "")}']`).click();
    }
    document.querySelectorAll(".toggle-filters").forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector(".mobile-drop").classList.toggle("active");
        });
    });


 
  }

})();
